// store/modules/user.js



import { Login, guideGet } from "@/api";
import { getToken, setsaToken, removeToken, removeUserInfo, setUserInfo, getUserInfo } from "@/utils/auth";
import router from '@/router'

export default {
    namespaced: true, // 命名空间模块化
    state: () => ({
        token: getToken() || '',
        userInfo: getUserInfo() || {},
        membershipRights: {
            documentNum_: 0,
            documentNum: 1
        },
        recharge: false,
        rechargeText: '',
    }),
    mutations: {
        SET_TOKEN: (state, token) => {
            setsaToken(token);
            console.log(token)
            state.token = token;
        },
        SET_USER_INFO: (state, userInfo) => {
            setUserInfo(userInfo)
            state.userInfo = userInfo;
        },
        SET_MEMBER: (state, membershipRights) => {
            state.membershipRights = membershipRights;
        },
        SET_RECHARGE: (state, obj) => {
            state.recharge = obj.recharge;
            state.rechargeText = obj.rechargeText || 'Insufficient credits — upgrade your plan to unlock more.';
        },
    },
    actions: {
        login({ commit, rootState, dispatch }, userInfo) {
            return new Promise((resolve, reject) => {
                Login(userInfo)
                    .then(res => {
                        console.log(res)
                        if (res.code == 200) {

                            const info = res.data;
                            // console.log(info.uinfo)
                            commit("SET_USER_INFO", info);

                            commit("SET_TOKEN", res.data.token);
                            setsaToken(res.data.token);
                            const name = rootState.app.toRouter.name || 'home';

                            console.log('登录后要跳转的路由：' + name)
                            console.log(rootState.app.toRouter)


                            if (rootState.app.toRouter.query.reload && rootState.app.toRouter.query.reload.includes('circle.slidesorator.com/play')) { //登录跳回社区
                                window.location.replace(rootState.app.toRouter.query.reload)
                            } else {
                                console.log(44444444)
                                // guideGet().then((r) => {
                                //     console.log(r)
                                //     if (r.code == 200) {
                                //         if (r.data.guideComplete == 1) {
    
    
                                //             dispatch("app/setIsGuide", false,{ root: true });
                                //             dispatch("app/setGuide", {
                                //                 guide: '',
                                //                 versionName: r.data.versionName
                                //             }, { root: true });
                                //         } else {
    
                                //             dispatch("app/setIsGuide", true, { root: true });
                                //             dispatch("app/setGuide", {
                                //                 guide: 'step1',
                                //                 versionName: r.data.versionName
                                //             }, { root: true });
                                //         }
                                //     }
                                    
                                    
                                // })
                                router.replace({
                                    name: name,
                                    params: rootState.app.toRouter.params ,
                                    query: rootState.app.toRouter.query ,
                                });
                            }
                        }
                        resolve(res);

                        })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        logou({ commit }) {
            commit("SET_TOKEN", '');
            commit("SET_TO_ROUTE", {
                name: 'Layout',
                params: {},
                query: {}
            })

            commit("SET_FROM_ROUTE", {
                name: 'Layout',
                params: {},
                query: {}

            })
            removeToken();
            removeUserInfo()
        },
        setUserInfo({ commit }, info) {
            commit("SET_USER_INFO", info);
        },
        setToken({ commit }, token) {
            commit("SET_TOKEN", token);
            console.log(token)
            setsaToken(token);
        },
        setMember({ commit }, membershipRights) {
            commit("SET_MEMBER", membershipRights);
        },
        set_recharge({ commit }, obj) {
            commit("SET_RECHARGE", obj);
        },
    },
    getters: {
        isAuthenticated(state) {
            return !!state.userInfo;
        },
    },
};
